export const Source = {
    0: "https://aimappro.com",
    1: "https://www.aishort.top",
    2: "https://github.com/PlexPt/awesome-chatgpt-prompts-zh",
    3: "https://flowgpt.com",
    4: "https://openprompt.co",
    5: "http://www.promptgenius.site/",
    99: "用户创建",
};